(function () {
    'use strict';
    var controllerId = 'purchaseOrderListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modal', 'NgTableParams', purchaseOrderListCtrl]);

    function purchaseOrderListCtrl(common, datacontext, $scope, $location, $modal, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.purchase_orders = [];
        vm.title = 'PO List View';

        vm.startSearch = 1;
        vm.query = {
            queryType:'array-count',
            search:'',
            vendor_id:'',
            po_status_id:'99',
            page:1,
            limit:20
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            vm.query[i] = vm.urlQuery[i];
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	for ( var i in newValue ) {
	        	if ( i !== 'page' && newValue[i] !== oldValue[i]) {
	            	vm.startSearch ++;
	            	if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true || oldValue[i] < 0 || angular.isUndefined(newValue[i]) == false ){
	            		get_purchase_orders();
	                }else{
	                    return "";
	                }
	            }
        	}
        	/*if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_purchase_orders();
                }
            }
            vm.grid = 0;*/
        });

        activate();

        function activate() {
            var promises = [get_purchase_orders(), get_purchase_order_status()];
            common.activateController(promises, controllerId)
                .then(function () {
                    //  log('Activated PO List View');
                });
        }

        function get_purchase_orders() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            },{

                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_purchase_orders(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

        function get_purchase_order_status() {
            return datacontext.get_po_status().then(function (httpResult) {
                vm.purchase_order_status = httpResult.data.data;
            });
        }

        $scope.create_po_modal = function () {
            // create PO
            var modalInstance = $modal.open({
                templateUrl: '/app/purchaseorders/partials/po_create_modal.html',
                controller:"poCreateModalCtrl",
                resolve: {
                    po_create: function () {
                        return $scope.po_create;
                    }
                }
            }).result.then(function(result){
                    get_purchase_orders();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'purchaseOrderPendingCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location', '$modal', 'NgTableParams', purchaseOrderPendingCtrl]);

    function purchaseOrderPendingCtrl(common, datacontext, $scope, $routeParams,  $location, $modal, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.purchase_orders = [];
        vm.title = 'PO List View';
        $scope.isLoading = 0;

        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            vendor_id: 1,
            is_orderable:1,
            is_active_override:1,
            is_fit_to_sell:1,
            days_on_hand_check:30,
            category_id:'',
            order_by:'est_days_left',
            order_dir:'ASC',
            page:1,
            limit:100
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_vendor_product_reorder();
                }
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_vendor_product_reorder(),
                getProductCategories(),
                get_vendors()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    //  log('Activated PO List View');
                });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
            });
        }

        function get_vendors() {
            return datacontext.get_vendors_v1().then(function (httpResult) {
                $scope.vendors = httpResult.data.data;
            });
        }

        function get_vendor_product_reorder() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    $scope.isLoading = 1;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_vendor_product_reorder(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        $scope.isLoading = 0;
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

    }
})();

(function () {
    'use strict';
    var controllerId = 'purchaseOrderCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$route', '$routeParams', '$modal', purchaseOrderCtrl]);

    function purchaseOrderCtrl(common, datacontext, $scope, $route, $routeParams, $modal) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        $scope.po_id = $routeParams.poid;

        $scope.action_tab = 'list';
        vm.title = 'PO Detail';

        activate();

        function activate() {
            var promises = [get_purchase_orders(),
                            get_export_po_list() ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated PO List View');
                });
        }
        $scope.getExportHeader = function () {
            return [
                "VendorSKU",
                "Title",
                "QtyOrdered",
                "QtyReceived",
                "QtyDamaged",
                "UPC",
                "ProductID"]
        };

        datacontext.get_vendors_list().then(function(httpResult) {
          $scope.vendors = httpResult.data.data;
        });

        function get_export_po_list(){
        	var payload = {
                    po_id:$scope.po_id
                };

        	return datacontext.get_export_po_list(payload).then(function(httpResult) {
                $scope.export_purchase_orders = httpResult.data;
            });
        }


        function get_purchase_orders() {

            var payload = {
                po_id:$scope.po_id
            };
            return datacontext.get_purchase_orders(payload).then(function (httpResult) {
                $scope.purchase_orders = httpResult.data.data;
                $scope.vendor_id = $scope.purchase_orders[0].vendor_id;

            });
        }

        $scope.edit_po_modal = function () {
            // merge order item w/order items
            $scope.po_edit = $scope.purchase_orders[0];

            // dismiss prev modal
            //modalInstance.dismiss('cancel');

            // create PO
            var modalInstance = $modal.open({
                templateUrl: '/app/purchaseorders/partials/po_edit_modal.html',
                controller:"poEditModalCtrl",
                resolve: {
                    po_edit: function () {
                        return $scope.po_edit;
                    }
                }
            }).result.then(function(result){

                    var payload = {
                        po_id:result.po_id
                    };

                    return datacontext.get_purchase_orders(payload).then(function (httpResult) {
                        vm.purchase_orders = httpResult.data.data;
                        $scope.vendor_id = $scope.purchase_orders[0].vendor_id;

                    });
                });

            vm.cancel = function () {

                modalInstance.dismiss('cancel');
            };
        };

        $scope.set_action = function (selected_action) {
            $scope.action_tab = selected_action;
        };

        vm.add_item_to_po = function (item) {
            $scope.create_poi = {
                po_id:$scope.po_id,
                vendor_product_id:item.vendor_product_id,
                qty_ordered:0,
                qty_received:0,
                cost:item.cost,
                vendor_id:item.vendor_id,
                vendor_image:item.vendor_image
            };

            datacontext.create_po_item($scope.create_poi).then(function (httpResult) {
                // open  update poi modal
                vm.update_poi_modal(item.po_item_id);
                get_purchase_orders();

            });
        };

        vm.update_poi_modal = function (idx) {

            $scope.po_item_update = {
                product_id:idx.product_id,
                product_title:idx.product_title,
                po_id:$scope.po_id,
                vendor_id:idx.vendor_id,
                po_item_id:idx.po_item_id,
                vendor_product_id:idx.vendor_product_id,
                vendor_sku:idx.vendor_sku,
                vendor_image:idx.vendor_image
            };

            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/purchaseorderproducts/partials/update_poi_modal.html',
                controller:"poiEditModalCtrl",
                resolve: {
                    po_item_update: function () {
                        return $scope.po_item_update;
                    }
                }
            }).result.then(function(){
                    // reload
                    $route.reload();
                });
        };

        $scope.product_create_modal = function (vendor_name) {
          console.log(vendor_name);
            $scope.product_man ={manufacturer_name:vendor_name};
            datacontext.get_manufacturers_by_name($scope.product_man).then(function (httpResult) {

              if(angular.isDefined(httpResult.data[0])){
                if(angular.isDefined(httpResult.data[0].manufacturer_id)){
                  $scope.manufacturer_id = httpResult.data[0].manufacturer_id;
                }else{
                  $scope.manufacturer_id = 0;
                }
              }else{
                $scope.manufacturer_id = 0;
              }
              console.log($scope.manufacturer_id);
              $scope.product_create = {po_id:$scope.po_id, vendor_id:$scope.manufacturer_id};
              console.log($scope.product_create);
              // merge order item w/order items
              var modalInstance = $modal.open({
                  templateUrl: '/app/products/partials/product_create_modal.html',
                  controller:"productCreateModalCtrl",
                  windowClass:'large',
                  resolve: {
                      product_create: function () {
                          return $scope.product_create;
                      }
                  }
              }).result.then(function(new_product){
                      vm.vendor_product_create_modal(new_product);
                  });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
                  get_purchase_orders();

              };
            });

        };

        vm.vendor_product_create_modal = function (new_product) {

            $scope.vendor_product_create = {
                po_id:$scope.po_id,
                product_id:new_product.product_id,
                product_title:new_product.product_name,
                vendor_id:$scope.vendor_id,
                vendors:$scope.vendors,
                vendor_stock_status_id:1,
                cost:0
            };

            console.log('new vp 428',$scope.vendor_product_create);

            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/vendorproducts/partials/vendor_product_create_modal.html',
                controller:"vendorProductCreateModalCtrl",
                windowClass:'large',
                resolve: {
                    vendor_product_create: function () {
                        return $scope.vendor_product_create;
                    }
                }
            }).result.then(function(new_vendor_product){
                    // create poi

                    $scope.create_poi = {
                        po_id:$scope.po_id,
                        vendor_product_id:new_vendor_product.vendor_product_id,
                        product_id:new_vendor_product.product_id,
                        qty_ordered:0,
                        qty_received:0,
                        cost:new_vendor_product.cost,
                        vendor_id:new_vendor_product.vendor_id,
                        vendor_image:new_vendor_product.vendor_image
                    };

                    datacontext.create_po_item($scope.create_poi).then(function (httpResult) {
                        // redirect to update poi
                        $scope.create_poi.po_item_id =  httpResult.data.data[0];
                        vm.update_poi_modal($scope.create_poi);
                    });
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
                get_purchase_orders();
            };
        };

    }
})();

(function () {
    'use strict';
    var controllerId = 'poTransferListCntl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$modal', poTransferListCntl]);

    function poTransferListCntl(common, datacontext, $scope, $routeParams, $modal) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        $scope.po_id = $routeParams.poid;

        vm.title = 'PO Detail';

        activate();

        function activate() {
            var promises = [get_purchase_orders(), get_transfer_po_items()];
            common.activateController(promises, controllerId)
                .then(function () {
                   // log('Activated PO List View');
                });
        }

        function get_purchase_orders() {
            return datacontext.get_purchase_orders({po_id:$scope.po_id}).then(function (httpResult) {
                vm.purchase_orders = httpResult.data.data;
            });
        }

        function get_transfer_po_items() {
            return datacontext.get_transfer_po_items({po_id: $scope.po_id}).then(function(httpResult) {
                vm.picklist = httpResult.data.data;
                $scope.pick_items_left = httpResult.data.count;
                log(httpResult);

                // hold
                $scope.hold = vm.picklist[0].sales_last_30_days;

                // transfer
                $scope.transfer = vm.picklist[0].on_hand - vm.picklist[0].sales_last_30_days;
                $scope.product_id = vm.picklist[0].product_id;

            });
        }

        // update PO Item
        $scope.update_po_item = function (item) {

            // build json to update
            var updateData = {
                po_id:$scope.po_id,
                po_item_id:item.po_item_id,
                qty_ordered:$scope.transfer,
                qty_shipped:item.qty_picked,
                note:item.note
            };

            datacontext.update_po_item(updateData).then(function (httpResult) {
               // reload page
                get_transfer_po_items();
            });
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'poCreateModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','po_create', poCreateModalCtrl]);

    function poCreateModalCtrl(common, datacontext, $scope, $modalInstance, po_create) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.submitted = 0;
        $scope.is_duplicate = 0;

        // Set PO Defaults
        $scope.po =
            {
                po_id:"",
                vendor_id:1,
                purchase_order_status_id:1,
                purchase_order_type_id:1
            };

        datacontext.get_vendors_v1().then(function(httpResult) {
            $scope.vendors = httpResult.data.data;
        });

        datacontext.get_po_status().then(function(httpResult) {
            $scope.po_status = httpResult.data.data;
        });

        datacontext.get_po_types().then(function(httpResult) {
            $scope.po_types = httpResult.data.data;

        });

        // Create Vendor Products
        $scope.create_po = function(isValid) {
            $scope.submitted = 1;

            if (isValid) {
                // Create Vendor Product
                datacontext.create_purchase_order($scope.po).then(function (httpResult) {
                    $scope.po.vendor_id = httpResult.data;
                    $scope.isCreated = true;
                    // Redirect
                    $modalInstance.close($scope.po.po_id);
                });
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'poEditModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','po_edit', poEditModalCtrl]);

    function poEditModalCtrl(common, datacontext, $scope, $modalInstance, po_edit) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.submitted = 0;
        $scope.is_duplicate = 0;

        // Set PO Defaults
        $scope.po = po_edit;

        if ( ! angular.isDate($scope.po.eta_on) ) {
            $scope.po.eta_on = NaN;
        }

        datacontext.get_vendors().then(function(httpResult) {
            $scope.vendors = httpResult.data.data;
        });

        datacontext.get_po_status().then(function(httpResult) {
            $scope.po_status = httpResult.data.data;
        });

        datacontext.get_po_types().then(function(httpResult) {
            $scope.po_types = httpResult.data.data;

            console.log("here");
        });

        // Create Vendor Products
        $scope.edit_po = function(isValid) {
            $scope.submitted = 1;
            if (isValid) {

                // Create Vendor Product
                datacontext.update_purchase_order($scope.po).then(function (httpResult) {
                    $scope.po.vendor_id = httpResult.data;
                    $scope.isCreated = true;
                    // Redirect
                    $modalInstance.close($scope.po);
                });
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
